/**
 * Environment Detection Utility
 * 
 * Works across both Vite (import.meta.env) and CRA/Webpack (process.env) build systems
 */

export const IS_DEV =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.DEV) ||
  (typeof process !== "undefined" && process.env && process.env.NODE_ENV === "development");
